import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { headerMenuBaseUseStyles } from 'components/layout/Header/common/styles/base';
import { Menu } from 'components/layout/Header/Header/Header';
import { HeaderMenuItem } from 'components/layout/Header/HeaderMenu/HeaderMenuItem';
import { headerMenuMobileUseStyles } from '../common/styles/mobile';

interface IProps {
  menu: Menu[];
  subMenu: Menu[];
  compact?: boolean;
}

export const HeaderMenuList: React.FC<IProps> = ({ menu, compact, subMenu }) => {
  const theme1 = useTheme();
  const matchesTablet = useMediaQuery(theme1.breakpoints.down('sm'));
  const classesBase = headerMenuBaseUseStyles({ matchesTablet: Boolean(matchesTablet) });
  const classesMobile = headerMenuMobileUseStyles({ matchesTablet: Boolean(matchesTablet) });
  const classes = { ...classesBase, ...classesMobile };

  return (
    <ul>
      <div className={classes.list}>
        {menu.map(tab => (tab.visible ? <HeaderMenuItem key={tab.value} tab={tab} compact={compact} /> : null))}
      </div>
      <div className={classes.list}>
        {subMenu.map(tab => (tab.visible ? <HeaderMenuItem key={tab.value} tab={tab} compact={compact} /> : null))}
      </div>
    </ul>
  );
};
